import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import atlas from 'azure-maps-control';
import axios from 'axios';
import { MdArrowBackIosNew } from "react-icons/md";
import { fetchUserDetails } from '../../Services/userService.js';
import { fetchEmpDetails } from '../../Services/ManagerService.jsx';
import VerifyAlert from '../MyWorklist/VerifyAlert';
import FadeLoader from "react-spinners/FadeLoader";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from 'react-toastify';

const ReviewAndConfirm = (props) => {
  const { overrides, handleReview, areasMarked, addressvalue, accountinfo, EmailId, latitude, longitude, toggleCondition, defaultaddress, timeValues, selectedValue, streetName, isSalespersonloggedin, myworklistredirect, isautoSave, parkinglotId, events, userData, selecetedAddress, SelectedBankDetailID, region, areaMarkedStatus, roboTaxiLimit, nickNameStatus, ...rest } = props;
  const hostPath = process.env.REACT_APP_API_BASE_URL;
  const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
  const [searchedLocation, setsearchedLocation] = useState('')
  const [City, setCity] = useState('')
  const [State, setState] = useState('')
  const [ZipCode, setZip] = useState('')
  const [BankDetails, setBankDetails] = useState({})
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [, setParkinglotId] = useState(null);



  const [areaMarkedError, setAreaMarkedError] = useState({});
  var map;
  useEffect(() => {
    (addressvalue.length !== 0) ? setsearchedLocation(addressvalue) : setsearchedLocation(defaultaddress.trim());
    setBankDetails(accountinfo);
    if (addressvalue.length !== 0) {
      const address = selecetedAddress.find((item) => item.freeformAddress === addressvalue);
      setCity(address?.municipality);
      setState(address?.countrySubdivisionName);
      setZip(address?.postalCode);
    } else {
      setCity(userData?.cityId);
      setState(userData?.stateId);
      setZip(userData?.zipcode);
    }

  }, [accountinfo, defaultaddress]);
  useEffect(() => {
    MapDetails();

  }, []);

  const getMarkerColor = (markerData, groups) => {
    if (markerData?.Name === "PSL - Parking Space Location" && markerData?.groupName) {
      const group = groups?.find(g => g.name === markerData.groupName);
      if (group) {
        console.log(`PSL ${markerData.pslName}: Group=${markerData.groupName}, Color=${group.color}`);
        return group.color;
      }
    }

    // Otherwise use the standard color map
    const colorMap = {
      "PSL - Parking Space Location": "#006400", // Dark Green
      "PKE - Parking Entrance": "#32CD32",       // Medium Green
      "PKX - Parking Exit": "#98FB98",           // Light Green
      "PUE - Pick Up Entrance": "#FFD700",       // Bright Yellow
      "PUL - Pick Up Location": "#FFC300",       // Medium Yellow
      "PUX - Pick Up Exit": "#FFFACD",           // Pale Yellow
      "DOE - Drop Off Entrance": "#00008B",      // Dark Blue
      "DOL - Drop Off Location": "#1E90FF",      // Medium Blue
      "DOX - Drop Off Exit": "#ADD8E6",          // Light Blue
    };

    return colorMap[markerData?.Name] || "#000000";
  };

  function MapDetails() {
    map = new atlas.Map('myMap', {
      center: [longitude || -122.18402494821507, latitude || 47.61373420362662],
      zoom: 18,
      language: 'en-US',
      style: 'satellite',
      view: 'Auto',
      authOptions: {
        authType: 'subscriptionKey',
        subscriptionKey: 'EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG'
      }
    });

    const zoomControl = new atlas.control.ZoomControl();
    map.controls.add(zoomControl, { position: 'bottom-right' });

    const myCustomJson = areasMarked;

    map.events.add('ready', function () {
      // Blue-pin for searched location
      if (latitude && longitude) {
        const img = document.createElement('img');
        img.src = '/icons/blue-pin.png';
        img.style.width = '80px';
        img.style.height = '130px';
        img.style.objectFit = 'contain';
        img.style.cursor = 'pointer';

        const bluePinMarker = new atlas.HtmlMarker({
          htmlContent: img,
          position: [longitude, latitude],
          anchor: 'bottom'
        });

        map.markers.add(bluePinMarker);
      }

      // Add other markers
      if (myCustomJson.length > 0) {
        for (let i = 0; i < myCustomJson.length; i++) {
          const markerData = myCustomJson[i];
          const lat = parseFloat(markerData?.Coordinates?.Latitude?.toFixed(6));
          const lon = parseFloat(markerData?.Coordinates?.Longitude?.toFixed(6));

          // Skip if it's the same as searched location
          if (lat === parseFloat(latitude?.toFixed?.(6)) && lon === parseFloat(longitude?.toFixed?.(6))) {
            continue;
          }

          const position = new atlas.data.Position(lon, lat);
          const nameSubstring = markerData?.Name?.substring(0, 3);
          const vehicleSize = markerData?.VehicleSpotSize || "";

          // ✅ Get color using the helper function with groups
          const backgroundColor = getMarkerColor(markerData, props.groups);

          // Calculate text color based on background
          const isColorDark = (color) => {
            const hex = color?.replace("#", "");
            const r = parseInt(hex?.substring(0, 2), 16);
            const g = parseInt(hex?.substring(2, 4), 16);
            const b = parseInt(hex?.substring(4, 6), 16);
            return ((r * 299 + g * 587 + b * 114) / 1000) < 128;
          };

          const textColor = isColorDark(backgroundColor) ? "white" : "black";

          const markerHTML = `
  <div style="position: relative; width: 35px; height: 80px; display: flex; flex-direction: column; align-items: center;">
    ${vehicleSize ? `
      <div style="
        position: absolute;
        top: -12px;
        left: 110%;
        transform: translateX(-50%);
        background-color: white;
        color: black;
        padding: 2px 5px;
        border-radius: 3px;
        font-size: 10px;
        font-weight: bold;
        box-shadow: 0 0 3px rgba(0,0,0,0.3);
      ">
        ${vehicleSize}
      </div>` : ''
            }
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="60" viewBox="0 0 24 36" fill="${backgroundColor}">
      <path d="M12 0C5.383 0 0 5.383 0 12c0 7.188 10.83 22.812 10.83 22.812C11.147 34.81 12 34.365 12 34.365S12.853 34.81 13.17 34.812C13.17 34.812 24 19.188 24 12C24 5.383 18.617 0 12 0z"/>
    </svg>
    <div style="
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: ${textColor};
      font-size: 8px;
      font-weight: bold;
    ">
      ${nameSubstring}
    </div>
    <div style="margin-top: -4px; font-size: 10px; font-weight: bold; color: black; background: white; padding: 2px 4px; border-radius: 3px; text-align: center;">
      ${markerData?.pslName || ""}
    </div>
  </div>`;

          const marker = new atlas.HtmlMarker({
            htmlContent: markerHTML,
            position: position,
            anchor: 'bottom'
          });

          map.markers.add(marker);
        }
      }
    });
  }

  const backButtonClick = () => {
    handleReview(false);
    props.backToBankdetails()
    toggleCondition('4 of 5 - Enter Bank Details')
    toggleCondition('5 of 5 - Review and Confirm')
  }
  const CoardinateDetails = areasMarked.map(item => ({
    Latitude: item.Coordinates.Latitude.toString(),
    Longitude: item.Coordinates.Longitude.toString(),
    Title: item.Coordinates.Title,
    pslName: item?.pslName || "",
    groupName: item?.groupName || "Default", // ✅ MUST be 'groupName' (camelCase)
    ID: item.id.toString(),
    VechileSpotSize: item.Coordinates.Title === "PSL - Parking Space Location" ? (item?.VehicleSpotSize || '') : '',
    ScheduleAvailability: item.ScheduleAvailability || "",
  }));

  const Scheduleavailability = events;
  useEffect(() => {
    if (areaMarkedError?.PSLMark && areaMarkedError.PSLMark.length > 0) {
      if (!toast.isActive("areaMarkedError")) {
        toast.error(areaMarkedError.PSLMark, {
          toastId: "areaMarkedError",
          position: "top-right",
          style: {
            maxWidth: "100%",
            wordWrap: "break-word",
            whiteSpace: "normal",
            textAlign: "center",
          },
        });
      }
    } else {
      toast.dismiss("areaMarkedError");
    }


  }, [areaMarkedError]);


  const validateFields = () => {
    let error = {};
    const validateField = (field, value, invalidMessage) => {
      if (!value) {
        error[field] = invalidMessage;
      }
    };
    const hasParkingSpaceLocation = props.areasMarked?.some(area => area?.Name === 'PSL - Parking Space Location');

    validateField("PSLMark", hasParkingSpaceLocation, "Please Mark at least one Parking Space");

    if (Object.keys(error).length > 0) {
      setAreaMarkedError(error);
      return false;
    }
    setAreaMarkedError({});
    return true;
  };


  const groupSchedules = (() => {
    const groupMap = {};

    events
      .filter(e => e.isMaster === true) // 🔥 ONLY MASTER EVENTS
      .forEach(evt => {
        const groupName = evt.groupName || "Default";

        if (!groupMap[groupName]) {
          groupMap[groupName] = [];
        }

        groupMap[groupName].push({
          id: evt.id,
          title: evt.title,
          start: evt.start,
          end: evt.end,
          recurrence: evt.recurrence || null,
          customRecurrenceCount: evt.customRecurrenceCount || null,
          selectedDays: evt.selectedDays || [],
          endType: evt.endType || "Never",
          endDateOn: evt.endDateOn || null,
          endAfter: evt.endAfter || null,
          isMaster: true,
          isActive: true
        });
      });

    return Object.keys(groupMap).map(groupName => ({
      groupName,
      schedules: groupMap[groupName]
    }));
  })();



  const handleButtonClick = async (e) => {
    setLoader(true);
    e.preventDefault();

    if (!validateFields()) {
      setLoader(false);
      return;
    }

    setIsButtonDisabled(true);

    const isEmployee = !!props.empId;

    const isRegisteredEmployee =
      isEmployee &&
      (props?.userData?.userId || props?.employeeData?.empId);

    const isVerifiedEmployee =
      isRegisteredEmployee &&
      (
        props?.userData?.isEmailPhoneVerified ||
        (props?.userData?.isEmailVerified && props?.userData?.isPhoneVerified) ||
        (props?.employeeData?.isEmailVerified && props?.employeeData?.isPhoneVerified)
      );

    const isConfirmClick =
      !props.verificationstatus &&
      (props.parkinglotObj?.status === "Draft" || !props.parkinglotObj);

    let finalStatus;

    // ✅ If record already exists
    if (props?.parkinglotObj?.status === "Active") {
      // NEVER downgrade
      finalStatus = "Active";
    }
    // ✅ First-time confirm
    else if (
      !props.verificationstatus &&
      isVerifiedEmployee
    ) {
      finalStatus = "Active";
    }
    // ✅ Everything else
    else {
      finalStatus = "Draft";
    }


    // ✅ Registered + verified + Confirm → Active
    if (isConfirmClick && isVerifiedEmployee) {
      finalStatus = "Active";
    }

    let createdBy;
    if (props?.employeeData) {
      createdBy = await fetchEmpDetails(props.employeeData.empRegistrationID);
    } else {
      createdBy = await fetchUserDetails(props?.userData?.entityRegistrationID);
    }

    const email1 = {
      EmailId,
      StreetName: streetName,
      EntityRegistrationID: props?.entityId || "",
      EmpRegistrationID: props?.empRegistrationId || "",
      ParkingLotAddress: searchedLocation,
      EmpId: props.empId,
      CreatedBy: props.empId ? props?.verifiedBy : createdBy?.firstName,
      ApprovedBy: props?.verifiedBy,
      Comment: "Auto Approved",
      CoardinateDetails,
      isParkingSpaceSelected: props.onlyPark,
      City,
      State,
      Zipcode: ZipCode,
      PricingPlanID: 2,
      BankDetailID: SelectedBankDetailID || 0,
      NickName: props.PropertyNickName,
      Region: region,
      MaxRoboTaxiSpots: props?.roboTaxiLimit,
      isRoboTaxiSelected: props?.RoboTaxis,
      groupSchedules,
      Status: finalStatus
    };


    const navigateAfterResponse = (response) => {
      if (response?.data) {
        if (myworklistredirect) {
          navigate("/reviewtab");
        } else {
          if (props.empId) {
            navigate(`/OwnerRegistrationDashboard/${props.userData?.firstName}`, {
              state: { ownerId: props.entityId }
            });
          } else {
            navigate("/viewparkinginfo");
          }
        }
        setLoader(false);
        window.location.reload();
      }
    };

    axios.post(
      props.parkinglotObj || parkinglotId?.parkingLotId
        ? `${hostPath}/api/UpdateParkingLotDetails`
        : `${hostPath}/api/ParkingLotBooking`,
      {
        ...email1,
        Parking_Lot_ID: props.parkinglotObj?.parking_Lot_ID || parkinglotId?.parkingLotId,
        id: props.parkinglotObj?.id || parkinglotId?.id,
        CreatedDate: props.parkinglotObj?.createdDate || parkinglotId?.createdDate,
        Status: finalStatus
      },
      { headers: { "x-functions-key": hostHeader } }
    )
      .then((response) => {
        if (response?.data && !parkinglotId) {
          setParkinglotId(response.data);
        }
        navigateAfterResponse(response);
        setLoader(false);
        // window.location.reload();
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoader(false);
      });
  };

  const handleShouldapprove = (val1, val2) => {
    setPopupVisible(val2);
  }
  return (
    <div className="col-md-12 ">
      <div class="row m-4">
        <div className="col-lg-12 col-md-12 col-sm-12" style={{ textAlign: "left" }}>
          <div><b>Review Marked Areas</b></div>
          <div>Take a close look at the areas you've marked on the map to ensure they accurately reflect your intended designations.</div>
        </div>
      </div>
      <div class="row m-4"  >

        <div id="reviewAndConfirm" style={{}}>
          <div class="row" style={{ textAlign: "left" }}>
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div> <b>Street Address : {searchedLocation}</b></div>
            </div>
          </div>
          <div class="row "  >
            <div class="col-lg-12 col-md-12 col-sm-12  m-3">
              <div>
                <div id="myMap" style={{ height: '750px', width: '100%', margin: '0% 0% 1% -1%' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader && (
        <div className="loader-overlay">
          <FadeLoader />
        </div>
      )}
      {isSalespersonloggedin ? (
        <>
          <div className=" mb-3" style={{ textAlign: "end", position: "relative" }}>
            <button
              type="button"
              className='icon-btn'
              onClick={backButtonClick}
              style={{ marginRight: "10px", position: "relative", right: "65px", bottom: "217px" }}>
              <MdArrowBackIosNew size={24} style={{ marginLeft: '-9px' }} title="Backward" />
            </button>
            <button
              type="button"
              className='icon-btn'
              onClick={handleButtonClick}
              style={{
                marginRight: "10px", position: "relative", right: "70px", bottom: "217px", width: "80px", background: "#3f8ed7",
                color: "white", fontWeight: "bold"
              }}>
              Save
            </button>
            <button
              type="button"
              className='icon-btn-finish'
              onClick={() => handleShouldapprove(true, true)}
              style={{ marginRight: "10px", position: "relative", right: "75px", bottom: "217px" }}>
              Verify
            </button>
          </div>
        </>
      ) : (
        <div className=" mb-3" style={{ textAlign: "end", position: "relative" }}>

          <button type="submit" className='finishbtn' onClick={backButtonClick} style={{ marginRight: "10px", position: "relative", right: "80px", bottom: "217px" }}>Go Back</button>
          <button type="submit" className='nextBtn' onClick={handleButtonClick} disabled={isButtonDisabled} style={{ marginRight: "10px", position: "relative", right: "76px", bottom: "217px" }}>
            {props.verificationstatus ? 'Save' : 'Confirm'}
          </button>
          <ToastContainer />

        </div>
      )}
      {isPopupVisible && (
        <VerifyAlert handleShouldapprove={handleShouldapprove} isPopupVisible={isPopupVisible} BankDetails={BankDetails} Scheduleavailability={Scheduleavailability} CoardinateDetails={CoardinateDetails}
          parkinglotObj={props.parkinglotObj} searchedLocation={searchedLocation} streetName={streetName} entityId={props.entityId} verifiedby={props.verifiedBy}
        />
      )}
    </div>
  )
}
export default ReviewAndConfirm;